document.addEventListener('DOMContentLoaded', () => {
  const collapsedHeight = 180; // ≈12rem
  const charLimit = 140;

  document.querySelectorAll('.overviewReviewItem').forEach(item => {
    const body = item.querySelector('.reviewItem__body');
    if (!body) return;

    const fullText = body.innerText.trim(); // Telt echte zichtbare tekst

    if (fullText.length <= charLimit) {
      body.style.height = collapsedHeight + 'px';

      // Onzichtbare placeholder toevoegen voor gelijke hoogte
      const placeholder = document.createElement('span');
      placeholder.className = 'reviewItem__toggle reviewItem__toggle--placeholder';
      body.insertAdjacentElement('afterend', placeholder);
      return;
    }

    // Dynamisch toggle toevoegen
    const toggle = document.createElement('a');
    toggle.href = '#';
    toggle.className = 'reviewItem__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Lees meer';
    body.insertAdjacentElement('afterend', toggle);

    // Initieel: vaste hoogte, zonder animatie
    body.style.height = collapsedHeight + 'px';
    body.style.overflow = 'hidden';

    let isExpanded = false;

    toggle.addEventListener('click', e => {
      e.preventDefault();

      const targetHeight = isExpanded
        ? collapsedHeight
        : body.scrollHeight;

      body.style.transition = 'height 0.4s ease';
      body.style.height = targetHeight + 'px';

      isExpanded = !isExpanded;
      toggle.textContent = isExpanded ? 'Lees minder' : 'Lees meer';
      toggle.setAttribute('aria-expanded', String(isExpanded));

      if (isExpanded) {
        body.addEventListener('transitionend', () => {
          body.style.height = 'auto'; // laat meeschalen bij content
        }, { once: true });
      }
    });
  });
});
